export default {
    getHeaderFields: state => state.headerFields,
    getViewHeaderFields: state => state.viewHeaderFields,
    getSearchFields: state => state.searchFields,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getViewActions: state => state.viewActions,
    getRowActions: state => state.rowActions,
    isLogOpen: state => state.logOpen,
    isCertOpen: state => state.certOpen,
    getEesztCertHeaderFields: state => state.eesztCertHeaderFields,
    getEesztCertActions: state => state.eesztCertActions
}
